import { api } from "./api";
import { CoOwnerResult, CoownerValidationResult, DogRegistrationIndividualRequest, DogRegistrationIndividualFeeData } from "@/types/portal/Registration";

export const searchCoOwner = async (membershipID: string): Promise<CoownerValidationResult[]> => {
    const { data } = await api.get<CoownerValidationResult[]>(`/DogRegistration/individual/coowner/${membershipID}`)
    return data;
}

export const getPuppyRegistrationInfoById = async (puppyId: number): Promise<any> => {
    const { data } = await api.get(`DogRegistration/individual/puppies/${puppyId}`);

    return data;
};


export const validateDogName = async (puppyId: number, name: string): Promise<any> => {
    const { data } = await api.get(`DogRegistration/individual/${puppyId}/validate/${name}`);

    return data;
};

export const registerDogIndividual = async(registerDTO: DogRegistrationIndividualRequest): Promise<any> => {
    try {
        const { data } = await api.post<object>(`/DogRegistration/individual/register`, registerDTO);
        return data;
    } catch (err) {
        return err;
    }
}
export const calculatePuppyRegistrafionFee = async (requestData: DogRegistrationIndividualFeeData): Promise<any> => {
    const { data } = await api.post<object>(`DogRegistration/individual/registration/fee`, requestData);

    return data;
};

export default {
    searchCoOwner,
    getPuppyRegistrationInfoById,
    validateDogName,
    registerDogIndividual,
    calculatePuppyRegistrafionFee,
}
